// src/components/sections/PartnerSection.jsx
import React from "react";
import { useTranslation } from "react-i18next";
import partnerbg from "../../assets/background/partnerbg.png";

import goverment from "../../assets/icon/goverment.png";
import enterprise from "../../assets/icon/enterprise.png";
import blockchain from "../../assets/icon/blockchain.png";
import bank from "../../assets/icon/bank.png";
import PartnerCard from "../common/PartnerCard";

export default function PartnerSection() {
  const { t } = useTranslation();

  const partners = [
    {
      icon: goverment,
      title: t("partners.items.goverment.title", {
        defaultValue: "Chính phủ, cơ quan nhà nước",
      }),
      description: t("partners.items.goverment.description", {
        defaultValue:
          "Điều phối, quản lý dữ liệu dân cư, văn bằng, dịch vụ công.",
      }),
    },
    {
      icon: bank,
      title: t("partners.items.bank.title", {
        defaultValue: "Ngân hàng, tổ chức tài chính",
      }),
      description: t("partners.items.bank.description", {
        defaultValue:
          "Tiên phong ứng dụng blockchain trong chuyển tiền, L/C, loyalty.",
      }),
    },
    {
      icon: enterprise,
      title: t("partners.items.enterprise.title", {
        defaultValue: "Doanh nghiệp dịch vụ số",
      }),
      description: t("partners.items.enterprise.description", {
        defaultValue:
          "Trực tiếp kết nối với người dùng, tích hợp blockchain vào thanh toán, hóa đơn, eKYC, loyalty.",
      }),
    },
    {
      icon: blockchain,
      title: t("partners.items.blockchain.title", {
        defaultValue: "Nhà cung cấp Blockchain, Ký số",
      }),
      description: t("partners.items.blockchain.description", {
        defaultValue:
          "Tiềm năng kết hợp blockchain để nâng cấp sang định danh và ký số phi tập trung.",
      }),
    },
  ];

  return (
    <section
      id="partners"
      className="relative isolate text-white bg-cover bg-center bg-no-repeat px-4 py-36 mobile:py-10 tabletair:py-16 tabletmini:py-16"
      style={{ backgroundImage: `url(${partnerbg})` }}
    >
      <div className="max-w-[1400px] mx-auto flex flex-col gap-[48px] mobile:gap-[20px] mobile:px-4 tabletpro:px-10 tabletair:px-10 tabletmini:px-10">
        {/* Headline */}
        <div className="flex flex-col gap-[16px] mx-auto">
          <p className="text-center text-[20px] mobile:text-[14px] font-medium text-brandBlue-500 tracking-wide uppercase">
            {t("partners.caption", { defaultValue: "HỢP TÁC" })}
          </p>
          <h2 className="text-center font-semibold text-[56px] mobile:text-[24px] tabletpro:text-[56px] tabletair:text-[36px] tabletmini:text-[32px] text-brandBlue-900 font-md max-w-[900px] mx-auto">
            {t("partners.headline", { defaultValue: "Đối tác đồng hành" })}
          </h2>
        </div>

        {/* Partner cards grid */}
        <div className="grid grid-cols-2 mobile:grid-cols-1 gap-4">
          {partners.map((p, i) => (
            <PartnerCard
              key={i}
              title={p.title}
              description={p.description}
              icon={p.icon}
              iconAlt={p.title}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
